module Visonum.BulkPingApp.Views.PrimaryButton
  ( view
  , Props(..)
  ) where

import Visonum.BulkPingApp.Prelude

import Halogen.HTML.Elements as H
import Halogen.HTML.Events as HE

type Props a =
  { label :: String
  , onClick :: a
  , disabled :: Boolean
  }

view :: forall w a. Props a -> AppHTML w a
view props =
  let
    elRoot = styleNode H.button
      "PrimaryButton"
      [ scopedSheet $ select_
          { height: "40px"
          , backgroundColor: "black"
          , color: "white"
          , borderRadius: "8px"
          , paddingRight: "10px"
          , paddingLeft: "10px"
          , width: "max-content"
          , cursor: if props.disabled then "auto" else "pointer"
          , opacity: if props.disabled then "0.5" else "1"
          , fontWeight: "semi-bold"
          }
      , scopedSheet $ select ":hover"
          { backgroundColor: "rgba(0,0,0,0.7)"
          }
      ]

  in

    elRoot
      ( if props.disabled then []
        else
          [ HE.onClick $ const props.onClick ]
      )
      [ text props.label
      ]